<template>
  <v-dialog v-model="getShowWelcomeDialog" width="70%" persistent>
    <v-card width="100%">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card-title>
            <v-row>
              <v-col align="center" cols="11">
                <span class="text-h4 pl-16 font-weight-bold">
                  {{ $t("headerDialog") }}
                </span>
              </v-col>
              <v-col cols="1" align="center" class="pa-0">
                <v-progress-circular
                  @click="closeWelcomeDialog()"
                  :rotate="180"
                  :size="50"
                  :width="7"
                  :value="closePercentage"
                  color="error"
                  class="my-2"
                >
                  <v-icon large color="error"> mdi-close </v-icon>
                </v-progress-circular>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider class="mx-2"></v-divider>

          <v-row no-gutters>
            <v-col cols="12" class="pa-8">
              <v-card flat>
                <v-card-text
                  class="text-justify text-h6 black--text"
                  style="line-height: 1.8"
                >
                  <div v-html="$t('welcomeContent')"></div>
                  <div class="d-flex align-center mt-4">
                    <p class="mb-0">
                      {{ $t("btnContent1") }}
                    </p>
                    <v-btn
                      color="primary"
                      large
                      class="ml-2"
                      href="https://www.getrobotsolutions.com/"
                      target="_blank"
                    >
                      {{ $t("btnContent2") }}
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12"> </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "imageViewer",
  data() {
    return {
      closePercentage: 0,
      timeout: 0,
      intervalObj: 0,
    };
  },
  computed: {
    ...mapGetters(["getShowWelcomeDialog"]),
  },
  watch: {},
  methods: {
    closeWelcomeDialog() {
      this.$store.commit("setShowWelcomeDialog", false);
    },
  },
};
</script>

<i18n>
{
  "en": {
    "headerDialog": "AI Kiosk Info",
    "welcomeContent": "<p> Welcome! I am an AI Based Kiosk Application to assist you during your visit to the oldest law school in the United States. Created by <strong>Advanced Robot Solutions (ARS)</strong> of Connecticut, this kiosk supports and assists <strong>W&M’s Center for Legal & Court Technology (CLCT)</strong> and the <strong>W&M Law School community</strong>. This kiosk is similar to those produced for courthouses throughout the United States.</p><p>I have been loaned, at no cost, to CLCT to demonstrate how this technology assists courthouse visitors while helping you with your inquiries. Feel free to ask the avatar a question — it will be happy to respond. As you might expect, the avatar may not always have an appropriate answer. CLCT is collecting those questions, then assigning the appropriate answers, to further improve my performance.</p><p>Your privacy is important to us. We confirm that this system does not record your voice for training or any other reason. While it utilizes a powerful Large Language Model (LLM), it is designed to operate in a strict and limited manner to prevent inaccuracies or hallucinations. Rest assured, we do not profile or save any personal details from your session.</p><p class='font-weight-medium mt-6'>Welcome and enjoy your visit!</p>",
    "btnContent1":"If you would like to know more about ARS’s AI court kiosks,products, and services, please request a discovery call by",
    "btnContent2":"clicking here"
  },
  "es": {
    "headerDialog": "Información del quiosco de IA",
    "welcomeContent": "<p> ¡Bienvenido/a! Soy una aplicación de quiosco con inteligencia artificial diseñada para ayudarle durante su visita a la facultad de derecho más antigua de Estados Unidos. Creado por Advanced Robot Solutions (ARS) de Connecticut, este quiosco apoya al Centro de Tecnología Legal y Judicial (CLCT) de la Universidad William & Mells (W&M) y a la comunidad de la Facultad de Derecho de W&M. Este quiosco es similar a los que se utilizan en los juzgados de todo Estados Unidos. Me han prestado gratuitamente al CLCT para demostrar cómo esta tecnología ayuda a los visitantes de los juzgados y responde a sus preguntas. No dude en preguntarle al avatar; con gusto le responderá. Como es de esperar, el avatar no siempre tendrá la respuesta adecuada. El CLCT recopila estas preguntas y asigna las respuestas correctas para mejorar mi funcionamiento. Su privacidad es importante para nosotros. Le confirmamos que este sistema no graba su voz para entrenamiento ni para ningún otro fin. Aunque utiliza un potente modelo de lenguaje extenso (LLM), está diseñado para operar de forma estricta y limitada para evitar imprecisiones o alucinaciones. Tenga la seguridad de que no creamos perfiles ni guardamos ningún dato personal de su sesión.</p><p class='font-weight-medium mt-6'>Bienvenido y disfrute de su visita!</p>",
    "btnContent1":"Para más información sobre los quioscos y servicios de ARS, solicite una llamada de exploración mediante",
    "btnContent2":"Haz clic aquí"
  }
}
</i18n>
